import { CONTRACT_ADDRESSES } from "./constants";

// Popular BSC tokens for PancakeSwap V2
export const BSC_TOKENS = [
    {
        address: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
        symbol: "WBNB",
        name: "Wrapped BNB",
        decimals: 18,
        logoURI:
            "https://assets.coingecko.com/coins/images/825/large/bnb-icon2_2x.png",
    },
    {
        address: "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56",
        symbol: "BUSD",
        name: "Binance USD",
        decimals: 18,
        logoURI:
            "https://assets.coingecko.com/coins/images/9576/large/BUSD.png",
    },
    // {
    //     address: "0x55d398326f99059fF775485246999027B3197955",
    //     symbol: "USDT",
    //     name: "Tether USD",
    //     decimals: 18,
    //     logoURI:
    //         "https://assets.coingecko.com/coins/images/325/large/Tether.png",
    // },
    {
        address: CONTRACT_ADDRESSES.USDT,
        symbol: "USDT",
        name: "Tether USD",
        decimals: 18,
        logoURI:
            "https://assets.coingecko.com/coins/images/325/large/Tether.png",
    },
    {
        address: "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d",
        symbol: "USDC",
        name: "USD Coin",
        decimals: 18,
        logoURI:
            "https://assets.coingecko.com/coins/images/6319/large/USD_Coin_icon.png",
    },
    {
        address: "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
        symbol: "CAKE",
        name: "PancakeSwap Token",
        decimals: 18,
        logoURI:
            "https://assets.coingecko.com/coins/images/12632/large/pancakeswap-cake-logo_%281%29.png",
    },
    {
        address: "0x2170Ed0880ac9A755fd29B2688956BD959F933F8",
        symbol: "ETH",
        name: "Ethereum Token",
        decimals: 18,
        logoURI:
            "https://assets.coingecko.com/coins/images/279/large/ethereum.png",
    },
    {
        address: "0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c",
        symbol: "BTCB",
        name: "Bitcoin BEP2",
        decimals: 18,
        logoURI:
            "https://assets.coingecko.com/coins/images/7598/large/wrapped_bitcoin_wbtc.png",
    },
    {
        address: "0x1D2F0da169ceB9fC7B3144628dB156f3F6c60dBE",
        symbol: "XRP",
        name: "XRP Token",
        decimals: 18,
        logoURI:
            "https://assets.coingecko.com/coins/images/44/large/xrp-symbol-white-128.png",
    },
    {
        address: "0x4338665CBB7B2485A8855A139b75D5e34AB0DB94",
        symbol: "LTC",
        name: "Litecoin Token",
        decimals: 18,
        logoURI:
            "https://assets.coingecko.com/coins/images/2/large/litecoin.png",
    },
    {
        address: "0x8fF795a6F4D97E7887C79beA79aba5cc76444aDf",
        symbol: "BCH",
        name: "Bitcoin Cash Token",
        decimals: 18,
        logoURI:
            "https://assets.coingecko.com/coins/images/780/large/bitcoin-cash.png",
    },
];

export const getTokenByAddress = (address) => {
    return BSC_TOKENS.find(
        (token) => token.address.toLowerCase() === address.toLowerCase()
    );
};

export const getTokenBySymbol = (symbol) => {
    return BSC_TOKENS.find(
        (token) => token.symbol.toLowerCase() === symbol.toLowerCase()
    );
};
